import React from 'react';
import { MDBCard, MDBCardBody } from 'mdb-react-ui-kit';

const ImageProcessing = () => {
  const processingData = [
    { label: 'Images Uploaded', value: 1247, color: '#6c757d', icon: '📸' },
    { label: 'Blurred Detected', value: 89, color: '#ffc107', icon: '🔍' },
    { label: 'Background Removed', value: 234, color: '#dc3545', icon: '✂️' },
    { label: 'Images Enhanced', value: 156, color: '#28a745', icon: '✨' }
  ];

  const maxValue = Math.max(...processingData.map(item => item.value));

  return (
    <MDBCard className="dashboard-card processing-card">
      <MDBCardBody>
        <div className="card-header">
          <h3 className="card-title">Image Processing & AI Insights</h3>
          <p className="card-subtitle">AI-powered image enhancement statistics</p>
        </div>
        
        <div className="processing-chart">
          {processingData.map((item, index) => (
            <div key={item.label} className="processing-bar-container">
              <div className="processing-info">
                <div className="processing-icon">{item.icon}</div>
                <div className="processing-details">
                  <div className="processing-label">{item.label}</div>
                  <div className="processing-value">{item.value.toLocaleString()}</div>
                </div>
              </div>
              <div className="processing-bar-track">
                <div 
                  className="processing-bar"
                  style={{
                    width: `${(item.value / maxValue) * 100}%`,
                    backgroundColor: item.color,
                    animationDelay: `${index * 0.2}s`
                  }}
                >
                  <div className="bar-glow"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="processing-summary">
          <div className="summary-stat">
            <span className="summary-label">Processing Rate</span>
            <span className="summary-value">94.2%</span>
          </div>
          <div className="summary-stat">
            <span className="summary-label">AI Accuracy</span>
            <span className="summary-value">97.8%</span>
          </div>
        </div>
      </MDBCardBody>
    </MDBCard>
  );
};

export default ImageProcessing;